import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
function Axis({
  radius,
  showAxisNumbers,
  tickMarkHeight = 5,
  textOffset = 15,
  ringThickness = 4,
  zoomLevel
}) {
  const height = (ringThickness + (showAxisNumbers ? textOffset + tickMarkHeight : 0)) / zoomLevel;
  const radiusToUse = showAxisNumbers ? radius + textOffset + tickMarkHeight : radius;
  const component = /* @__PURE__ */ jsxs("g", { className: "veAxis", children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        className: "veAxisLine veAxisOuter",
        r: radiusToUse + ringThickness,
        style: { fill: "#ffffff00", stroke: "black", strokeWidth: 0.5 }
      },
      "circleOuter"
    ),
    /* @__PURE__ */ jsx(
      "circle",
      {
        className: "veAxisLine veAxisInner",
        r: radiusToUse,
        style: { fill: "#ffffff00", stroke: "black", strokeWidth: 0.5 }
      },
      "circle"
    )
  ] }, "veAxis");
  return {
    component,
    height
  };
}
export default Axis;
